import React from 'react'
import sw from '../../utils/switch'
import loadable from '@loadable/component'
import withComponentBase from '../helpers/with-component-base'

const Grid = loadable(() => import('./collection-grid'))
const Inline = loadable(() => import('./collection-inline'))
const Logos = loadable(() => import('./collection-image-logo'))
const CollectionCarousel = loadable(() => import('./collection-carousel'))
const Tabs = loadable(() => import('./collection-tabs'))

// eslint-disable-next-line import/no-anonymous-default-export
export default withComponentBase(
  ({ layout, ...props }) =>
    sw({
      carousel: () => <CollectionCarousel {...props} />,
      grid: () => <Grid {...props} />,
      inline: () => <Inline {...props} />,
      logos: () => <Logos {...props} />,
      'large-logos': () => <Logos {...props} variant='large' />,
      tabs: () => <Tabs {...props} />,
      default: () => null,
    })(layout),
  {
    withHeaderFooter: true,
  },
)
